import React from 'react';
import { get, has, toUpper } from 'lodash';
import styled from 'styled-components';
import { FlexContainer } from 'base-components';
import {
    ExcessTotal,
    Number,
    Text,
    GetUnitPrice,
    Image,
    StatusTag,
    ConditionalRender
} from '../../../../../../components/common';

const ClickableLink = styled.a`
    color: black;
`;

export const substituteColumns = [
    {
        title: 'Imagen',
        dataIndex: 'imageUrl',
        key: 'imageUrl',
        index: 1,
        styled:{width:"75px", height:"75px"},
        render: (item, dataindex) => {
            return <Image src={get(item, 'imageUrl')} style={{borderWidth:'1px solid #B6C1C8', borderRadius:"8px"}}  />;
        }
    },
    {
        dataIndex: 'name',
        key: 'product',
        width: 150,
        index: 2,
        render: (item, dataIndex, { onRowClick = () => (null) }) => (
            <div>
                <ClickableLink onClick={(e) => { e.preventDefault(); onRowClick(item); }}>
                    <p>{get(item, dataIndex)}</p>
                </ClickableLink>
                <FlexContainer mY={5} align='center'>
                    <Text text={get(item, 'ean', 'No Disponible')} color='#666666' size={11} lineHeight={1} />
                </FlexContainer>
                <ConditionalRender condition={has(item, 'priceTags.0.rateAndBenefit.name')}>
                    <Text text={get(item, 'priceTags.0.rateAndBenefit.name')} tiny color='#666666' />
                </ConditionalRender>
            </div>
        )
    },
    {
        title: 'Marca',
        dataIndex: 'brandName',
        key: 'brandName',
        index: 3,
        columnStyle: { textAlign: 'left' },
        render: (item, dataIndex) => {
            const brandName = get(item, dataIndex, '-');
            return (
                <div>
                    <p>{brandName}</p>
                </div>
            );
        }
    },
    {
        title: '',
        dataIndex: 'quantity',
        key: 'quantity',
        index: 4,
        render: (item, dataIndex) => {
            return <Text text={"-"} />
        }
    },
    {
        title: '',
        dataIndex: 'pickingQuantity',
        key: 'picked',
        index: 5,
        render: (item, dataIndex) => {
            const status = get(item, 'picking.status');
            const shouldHide = ['FREE_PICKING_ACCEPTED', 'SUBSTITUTE_CONFIRMED'];
            const quantity = get(item, dataIndex, '0');
            const measureUnit = get(item, 'unit', 'un');
            const value = get(item, dataIndex);
            const valueToShow = measureUnit === 'kg' ? parseFloat(value).toFixed(3) : value;
            if (String(quantity) === '0' || shouldHide.includes(status)) return _renderCell(null, null);
            return <Text text={`${(String(valueToShow).replace('.', ','))} ${measureUnit}`} />;
        }
    },
    {
        title: '',
        dataIndex: 'stock',
        key: 'stock',
        index: 6,
        render: (item, dataIndex) => {
            const value = get(item, dataIndex, 0);
            return <Text size={11} text={`${value || '0'} ${toUpper(get(item, 'unit', 'un'))}`} strong />;
        }
    },
    {
        title: '',
        dataIndex: 'picking.productId.info',
        key: 'audit-rules',
        index: 8,
        render: () => (<Text text='-' />)
    },
    {
        title: 'Diferencia precio',
        dataIndex: 'excess',
        key: 'excess',
        index: 9,
        render: (item, dataIndex) => {
            const excessData = get(item, dataIndex);
            return <ExcessTotal style={{ justifyContent: "center" }} item={excessData} />
        }
    },
    {
        title: '',
        dataIndex: 'basePrice',
        key: 'client',
        index: 10,
        render: (item) => (
            <GetUnitPrice item={item}>
                {({ priceTags, listPrice, price }) => (
                    <>
                        {priceTags && (
                            <div>
                                <span>
                                    <del style={{ color: '#666666' }}>
                                        <Number value={listPrice || 0} />
                                    </del>
                                </span>
                            </div>
                        )}
                        <div>
                            <span>
                                <Number value={price || 0} />
                            </span>
                        </div>
                    </>
                )}
            </GetUnitPrice>
        )
    },
    {
        title: '',
        dataIndex: 'sellingPrice',
        key: 'sale_price',
        index: 11,
        render: (item, dataIndex) => {
            const { quantity = 0 } = item;
            return (
                <div>
                    <span>
                        <Number value={get(item, dataIndex) * parseFloat(quantity)} />
                    </span>
                </div>
            );
        }
    },
    {
        title: '',
        dataIndex: 'picking',
        key: 'final_price',
        index: 12,
        render: (item) => {
            const { sellingPrice = 0, pickingQuantity = 0, unitMultiplier = 1 } = item;
            const value = parseInt(sellingPrice) * (parseFloat(pickingQuantity) / parseFloat(unitMultiplier));
            return (
                <div>
                    <strong>
                        {value > 0 ? <Number value={value} /> : '-'}
                    </strong>
                </div>
            );
        }
    }
];

export const excessColumns = [
    {
        title: 'excess',
        index: 1,
        dataIndex: 'picking.excess',
        render: (item, dataIndex) => {
            const excessData = get(item, dataIndex);
            return excessData ? <ExcessTotal item={excessData} /> : <Text text='-' />;
        }
    }
];